<template>
  <v-select
    :model-value="modelValue"
    @update:modelValue="$emit('update:modelValue', $event)"
    :items="options"
    :item-title="itemTitle"
    :item-value="itemValue"
    return-object
    variant="outlined"
    density="compact"
    hide-details
    style="width: 100%"
    class="rem"
  >
    <template #selection="{ item }">
      <div v-if="item && typeof item === 'object'">
        <div class="option-title">{{ item.raw.title }}</div>
      </div>
    </template>

    <template #item="{ item, props }">
      <v-list-item v-bind="props">
        <template #default>
          <div class="d-flex flex-column">
            <!-- <span class="option-title">{{ item.raw.title }}</span> -->
            <span class="option-description">{{ item.raw.description }}</span>
          </div>
        </template>
      </v-list-item>
    </template>
  </v-select>
</template>

<script>
export default {
  name: "PerformanceSelect",
  props: {
    modelValue: Object,
    options: Array,
    itemTitle: {
      type: String,
      default: "title",
    },
    itemDescription: {
      type: String,
      default: "description",
    },
    itemValue: {
      type: String,
      default: "id",
    },
  },
  emits: ["update:modelValue"],
};
</script>

<style scoped>
.option-title {
  font-weight: 600;
  font-size: 14px;
  color: #222;
}
.option-description {
  font-size: 13px;
  color: #666;
}
.v-field__outline {
  display: none !important;
}
.v-field--variant-outlined .v-field__outline {
  display: none !important;
}
.v-input--horizontal {
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 0.5rem;
  padding: 0.2rem;
}
.rem .v-field__outline {
  display: none !important;
}
/* إخفاء الخط الخارجي لـ v-select */
::v-deep(.v-field__outline) {
  display: none !important;
}

/* ولو عايز تعدل باقي شكل الفيلد */
::v-deep(.v-input--horizontal) {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 0.25rem;
}
::v-deep(.v-text-field .v-field__outline) {
  display: none !important;
}

</style>
